<form [formGroup]="formGroup">
    <div fxLayout="column">
        <fieldset fxFlex="1 1 auto" fxLayout="column">
            <legend>Add/Edit</legend>
            <div fxFlex="1 1 auto" fxLayout="row">
                <button mat-icon-button (click)="openColumnChooserDialog()">
                    <mat-icon>search</mat-icon>
                </button>
                <mat-form-field fxFlex="1 1 35%" floatLabel="always">
                    <mat-label>Column</mat-label>
                    <mat-select formControlName="filterColumn">
                        <mat-optgroup *ngFor="let columnGroup of columnGroups; let i = index"
                            [label]="columnGroupLabels[i]">
                            <mat-option *ngFor="let column of columnGroup" [value]="column.value">
                                {{column.label}}</mat-option>
                        </mat-optgroup>
                    </mat-select>
                </mat-form-field>
                <mat-form-field fxFlex="0 1 15%" floatLabel="always">
                    <mat-label>Operator</mat-label>
                    <mat-select formControlName="filterOperator" (selectionChange)="onFilterOperatorChange($event)">
                        <mat-option *ngFor="let operator of operators" [value]="operator.value">
                            {{operator.label}}</mat-option>
                    </mat-select>
                </mat-form-field>
                <mat-form-field fxFlex="1 1 35%" floatLabel="always"
                    [fxHide]="isFilterValueUnnecessary(filterOperator.value)">
                    <textarea matInput placeholder="Value" cdkTextareaAutosize formControlName="filterValue"
                        *ngIf="!distinctValues || !filterColumn.value || !distinctValues[filterColumn.value]"
                        name="filterValue"></textarea>
                    <ng-container *ngIf="distinctValues && filterColumn.value && distinctValues[filterColumn.value]">
                        <mat-select placeholder="Value" formControlName="filterValue" name="filterValue"
                            *ngIf="filterOperator.value !== 'IN' && filterOperator.value !== 'NOT_IN'">
                            <mat-option *ngFor="let option of distinctValues[filterColumn.value]" [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                        <mat-select placeholder="Value" formControlName="filterInValues" name="filterInValues"
                            *ngIf="filterOperator.value === 'IN' || filterOperator.value === 'NOT_IN'" multiple>
                            <mat-option *ngFor="let option of distinctValues[filterColumn.value].sort()"
                                [value]="option">
                                {{ option }}
                            </mat-option>
                        </mat-select>
                    </ng-container>
                </mat-form-field>

                <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                    [fxHide]="filterOperator.value !== 'BETWEEN' && filterOperator.value !== 'NOT_BETWEEN'">
                    <input matInput placeholder="Between" formControlName="filterBetweenValue1"
                        name="filterBetweenValue1">
                </mat-form-field>
                <mat-form-field fxFlex="1 1 15%" floatLabel="always"
                    [fxHide]="filterOperator.value !== 'BETWEEN' && filterOperator.value !== 'NOT_BETWEEN'">
                    <input matInput placeholder="and" formControlName="filterBetweenValue2" name="filterBetweenValue2">
                </mat-form-field>

                <button mat-icon-button aria-label="Add Filter" (click)="addFilter($event)">
                    <mat-icon>add</mat-icon>
                </button>
                <button mat-icon-button aria-label="Update Filter" (click)="updateFilter($event)"
                    [disabled]="!selectedFilter">
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </fieldset>
        <fieldset fxFlex="1 1 auto" fxLayout="column">
            <legend>Enabled Filters</legend>
            <mat-table fxFlex="1 1 auto" #filterTable [dataSource]="filterDataSource" class="filter-table">
                <ng-container matColumnDef="column">
                    <mat-header-cell *matHeaderCellDef>Column</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        {{aliasedColumnName(element.attributeColumn)}}
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="operator">
                    <mat-header-cell *matHeaderCellDef>Operator</mat-header-cell>>
                    <mat-cell *matCellDef="let element"> {{element.operator}} </mat-cell>>
                </ng-container>
                <ng-container matColumnDef="value">
                    <mat-header-cell *matHeaderCellDef>Value</mat-header-cell>
                    <mat-cell *matCellDef="let element"> {{element.value}} </mat-cell>
                </ng-container>
                <ng-container matColumnDef="delete" stickyEnd>
                    <mat-header-cell *matHeaderCellDef>Delete</mat-header-cell>
                    <mat-cell *matCellDef="let element">
                        <button mat-icon-button (click)="deleteRow(element)">
                            <mat-icon>delete</mat-icon>
                        </button>
                    </mat-cell>
                </ng-container>
                <mat-row *matRowDef="let row; columns: ['column','operator','value', 'delete']"
                    (click)="onFilterSelect(row)" [style.background]="filterSelection.isSelected(row) ? '#30bceb' : ''">
                </mat-row>
                <mat-row *matNoDataRow>
                    <td class="mat-cell" colspan="4">No filters defined</td>
                </mat-row>
            </mat-table>
        </fieldset>
    </div>
</form>